import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Tooltip, Button, Row, notification, Popconfirm, Table, Modal, Icon, Statistic, Divider, Tag, Descriptions, Drawer, Switch, Select, DatePicker, Input, InputNumber, Dropdown, Menu } from 'antd';
import { showErrorInNotification, formatMoney, schema_to_field } from '../../lib/util';
import BatchItemSelector from '../../components/batch_item.selector';
import { PopUpForm } from '../../lib/ui/popupform';
import ErrorWrapper from '../../lib/error_wrapper';
import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import moment from 'moment'
import ModalTransactionDetail from '../../components/modal_transaction_detail';
import { COLORS } from '../theme';
import { FilterListOutlined, ExpandLessOutlined, ExpandMoreOutlined, RefreshOutlined, SyncAltRounded, KeyboardArrowDownOutlined, FilterList, LibraryAdd } from '@material-ui/icons';
import { CustomButton, CustomSwitch, TransparentButton } from '../../components/basic_items';
import TransactionBatchIndividualItem from '../../components/transaction_batchindividual_item';
import TransactionBatchAggregatedItem from '../../components/transaction_batchaggregated_item';



export const OURS_KEY = 'our';
export const THEIRS_KEY = 'their'

const peers_cols = ({ onViewDetailClicked, onRemoveClicked }) => [
    {
        // title: "Type",
        dataIndex: "type",
        width: 50,
        key: 'type',
        render: (value) => <div style={{ backgroundColor: value == 'C' ? '#4062BB' : '#4E937A' }} className='dr-cr-text'>
            {value}
        </div>
    },
    {
        title: "Txn Date",
        dataIndex: "txn_date",
        width: 120,
        key: 'txn_date'
    }, {
        title: "Tran ID",
        dataIndex: "transaction_id",
        width: 100,
        key: 'transaction_id'
    }, {
        title: "Particular",
        dataIndex: "description",
        key: 'description'
    }, {
        title: "Amount",
        dataIndex: "amount",
        width: 120,
        key: 'amount',
        render: (amount = 0) => formatMoney(amount, 2, '.', ',')
    },
    {
        title: "",
        dataIndex: "id",
        width: 50,
        key: 'action',
        render: (id) => <span><Button type='link' onClick={() => {
            typeof onViewDetailClicked === 'function' && onViewDetailClicked(id)
        }}>View</Button>
            <Divider type='vertical' />
            <Popconfirm title="Do you want to remove this peer?" onConfirm={() => {
                typeof onRemoveClicked === 'function' && onRemoveClicked(id)

            }}><Button style={{
                color: 'red'
            }} type='link' >Remove</Button></Popconfirm>
        </span>
    }
]

class BatchMode extends Component {
    constructor(props) {
        super(props)

        this.state = {
            // supports manual or recommended or tabular
            batch_mode: 'Manual',
            loading: false,
            batch_for: OURS_KEY,
            selected_left: null,
            selected_left_index: null,

            selected_left_transaction: {},
            aggregated_transactions: [],
            loading_ours: true,
            loading_theirs: true,


            filter_left: {
                per_page: 20,
                page: 1,
                source_id: this.props.source_id
            },
            filterVisible_left: false,
            filterVisible_right: false,
            filterVisible_right_recommendation: false,
            filter_right: {
                per_page: 20,
                page: 1,
                source_id: this.props.source_id
            },
            filter_right_recommendation: {
                type: OURS_KEY,
                per_page: 20,
                page: 1,
                source_id: this.props.source_id
            },


            service_list: [],

            our_error: false,
            their_error: false,
            selected_right: null,
            create_form_data: {},



            left_rowData: [],
            left_rowMeta: {},
            right_rowData: [],
            right_rowMeta: {},

            plugins_data: {},
            plugins_extra_data: {},
            plugins_extra_schema: [],
            selected_plugin: null,
            extra_plugin_data_modal: false,


            selected_right_txn_for_batch: []

        };

        this.list_plugins = RESTExecutor.list().config({
            url: '/manual-batchers',
            params: {
                pagination: false
            }
        }).callbacks((success) => {
            let plugins_data = {};
            success.result.rows.map((item) => {
                plugins_data[item.id] = item
            });
            this.setState({
                plugins_data
            })
            console.log("plugins are", success.result)
        }).connect(props.domains.batching);


        this.list_our_aggregated = RESTExecutor.list().config({
            label: 'our_aggregated',
            params: {
                ...this.state.filter_left
            }
        }).callbacks((success) => {
            this.setState({
                left_rowData: success.result.rows || [],
                left_rowMeta: success.meta || {}
            })
        }).forId(props.reconciler_id).connect(props.domains.batching);

        this.list_their_aggregated = RESTExecutor.list().config({
            label: 'their_aggregated',
            params: {
                ...this.state.filter_right
            }
        }).callbacks((success) => {
            this.setState({
                left_rowData: success.result.rows || [],
                left_rowMeta: success.meta || {}
            })
        }).forId(props.reconciler_id).connect(props.domains.batching);

        this.list_our_normal = RESTExecutor.list().config({
            label: 'our_normal',
            params: {
                ...this.state.filter_left
            }
        }).callbacks((success) => {
            this.setState({
                right_rowData: success.result.rows || [],
                right_rowMeta: success.meta || {}
            })
        }).forId(props.reconciler_id).connect(props.domains.batching);

        this.list_their_normal = RESTExecutor.list().config({
            label: 'their_normal',
            params: {
                ...this.state.filter_right
            }
        }).callbacks((success) => {
            this.setState({
                right_rowData: success.result.rows || [],
                right_rowMeta: success.meta || {}
            })
        }).forId(props.reconciler_id).connect(props.domains.batching);

        this.detail_transaction = RESTExecutor.detail().config({
            label: 'transactiondetail'
        }).callbacks((success) => {
            this.setState({
                selected_left_transaction: success.result,
            });
        }).connect(props.domains.allData);

        this.list_recommended = RESTExecutor.list().config({
            label: 'recommended_batch'
        }).callbacks((success) => {
            this.setState({
                right_rowData: success.result.rows || [],
                right_rowMeta: success.meta || {}
            })
        }).forId(props.reconciler_id).connect(props.domains.batching);

        this.list_plugin_recommended = RESTExecutor.list().config({
            label: 'recommended_plugin_batch'
        }).callbacks((success) => {
            this.setState({
                right_rowData: success.result.rows || [],
                right_rowMeta: success.meta || {}
            })
        }).forId(props.reconciler_id).connect(props.domains.batching);


        this.create_aggregate = RESTExecutor.post().config({
            label: 'create_batch_v2'
        }).callbacks((success) => {
            notification.success({
                message: "Transaction Batched"
            });
            this.setState({
                selected_right: null,
                selected_right_txn_for_batch:[]
            })
            this.state.batch_for == OURS_KEY ? this.reloadForOurs() : this.reloadForTheirs()

        }, (error) => {
            showErrorInNotification(error);
        }).forId(props.reconciler_id).connect(props.domains.batching);

        this.delete_aggregate=RESTExecutor.post().config({
            label:'delete_aggregated'
        }).callbacks((success)=>{
            notification.success({
                message: "Transaction Unbatched"
            });
            this.setState({
                selected_left: null,
                selected_left_transaction: null,
                selected_left_index: null,
                batch_mode: 'Manual',
                selected_right_txn_for_batch:[]
            }, () => {
                if (this.state.batch_for == OURS_KEY) {
                    this.list_our_normal.execute();
                    this.list_our_aggregated.execute();
                } else {
                    this.list_their_normal.execute();
                    this.list_their_aggregated.execute();
                }
            })
        },(error)=>{
            showErrorInNotification(error);
        }).forId(props.reconciler_id).connect(props.domains.batching);

        this.list_peers = RESTExecutor.list().config({
            label: 'list_batch_v2',
            params: {
                pagination: false
            }
        }).forId(props.reconciler_id).connect(props.domains.batching);

        this.add_peers = RESTExecutor.post().config({
            label: 'list_batch_v2',
            params: {}
        }).forId(props.reconciler_id).callbacks((success) => {

            let transaction = success.result.detail || {};

            // this.detail_transaction.forId(new_id).execute();
            this.list_peers.config({
                params: {
                    txn_id: transaction.id,
                    pagination: false
                }
            }).execute();


            if (this.state.batch_for == OURS_KEY) {
                if (this.state.batch_mode == 'Recommended') {
                    this.list_recommended.execute();
                } else {
                    this.list_our_normal.execute();
                }
                // this.list_our_aggregated.execute();

            } else {
                if (this.state.batch_mode == 'Recommended') {
                    this.list_recommended.execute();
                } else {
                    this.list_their_normal.execute();
                }
                // this.list_their_aggregated.execute();
            }


            let left_list = this.state.left_rowData;
            if (left_list[this.state.selected_left_index]) {
                left_list[this.state.selected_left_index] = {
                    ...left_list[this.state.selected_left_index],
                    ...transaction,
                }
            }
            this.setState({ selected_left: transaction.id, selected_left_transaction: transaction, left_rowData: left_list ,selected_right_txn_for_batch:[]});


        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.batching);



        this.remove_peers = RESTExecutor.post().config({
            label: 'remove_from_batch_v2',
            params: {

            }
        }).forId(props.reconciler_id).callbacks((success) => {
            // check here
            if (success.result && success.result.deleted) {
                let transaction = success.result.detail || {};

                // this.detail_transaction.forId(new_id).execute();
                this.list_peers.config({
                    params: {
                        txn_id: transaction.id,
                        pagination: false
                    }
                }).execute();
                // last peer deleted
                if (this.state.batch_for == OURS_KEY) {
                    this.list_our_normal.execute();
                } else {
                    this.list_their_normal.execute();
                }
                let left_list = this.state.left_rowData;
                console.log("deleted", success.result)
                try {
                    left_list.splice(this.state.selected_left_index, 1);
                } catch (e) {
                }
                this.setState({
                    selected_left: null,
                    selected_left_transaction: {},
                    batch_mode: 'Manual',
                    left_rowData: left_list,
                    selected_left_index: null
                });
            } else {

                // aggregated not deleted
                if (this.state.batch_for == OURS_KEY) {
                    if (this.state.batch_mode == 'Recommended') {
                        this.list_recommended.execute();
                    } else {
                        this.list_our_normal.execute();
                    }
                } else {
                    if (this.state.batch_mode == 'Recommended') {
                        this.list_recommended.execute();
                    } else {
                        this.list_their_normal.execute();
                    }
                }
                console.log("not deleted", success.result)
                let transaction = success.result.detail || {};

                let left_list = this.state.left_rowData;
                console.log("left list", left_list)
                if (left_list[this.state.selected_left_index]) {
                    console.log("left list has value", left_list[this.state.selected_left_index])

                    left_list[this.state.selected_left_index] = {
                        ...left_list[this.state.selected_left_index],
                        ...transaction
                    }
                    console.log("new value,", left_list)
                }

                this.setState({ selected_left: transaction.id, selected_left_transaction: transaction, left_rowData: left_list });
                // this.detail_transaction.forId(new_id).execute();
                this.list_peers.config({
                    params: {
                        txn_id: transaction.id,
                        pagination: false
                    }
                }).execute();
            }

        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.batching);



        this.list_services_fordatatype = RESTExecutor.list().config({
            label: 'datatype_services',
            params: {
                pagination: false
            }
        }).callbacks((success) => {
            this.setState({
                service_list: success.result.rows
            })
        }, (error) => {
            showErrorInNotification(error);
            this.setState({
                service_list: []
            })
        }).connect(props.domains.allData);


        let reconciler = this.props.reconciler || {};

        // default ours side
        this.list_services_fordatatype.forId(reconciler.our_data_type_id).execute();
        this.list_plugins.execute()



        this.list_our_aggregated.execute();
        this.list_our_normal.execute();

        this.drawer_container = React.createRef();
    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        // console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback(newData)
        })
    }



    reloadForOurs = () => {
        let reconciler = this.props.reconciler;
        this.list_services_fordatatype.forId(reconciler.our_data_type_id).execute();
        this.list_our_aggregated.execute();
        this.list_our_normal.execute()
    }

    reloadForTheirs = () => {
        let reconciler = this.props.reconciler;
        this.list_services_fordatatype.forId(reconciler.their_data_type_id).execute();
        this.list_their_aggregated.execute();
        this.list_their_normal.execute();
    }

    render() {
        const { batch_for, batch_mode, selected_left, selected_left_transaction, filterVisible_left, filterVisible_right, filter_left, filter_right, service_list, filterVisible_right_recommendation, filter_right_recommendation

            ,
            left_rowData, left_rowMeta, right_rowData, right_rowMeta,
            plugins_data,
            plugins_extra_data,
            selected_plugin, plugins_extra_schema

        } = this.state;

        let create_aggregate_resp = this.create_aggregate.response();
        let add_peers_resp = this.add_peers.response();
        let list_peers_resp = this.list_peers.response();
        let remove_peers_resp = this.remove_peers.response();

        let peer_list = (list_peers_resp.result && list_peers_resp.result.rows) || [];

        let left_side = batch_for == OURS_KEY ? this.list_our_aggregated : this.list_their_aggregated;
        let right_side = batch_for == OURS_KEY ? this.list_our_normal : this.list_their_normal;
        if (batch_mode == 'Recommended') {
            // assign recommended resp
            right_side = this.list_recommended
            if (selected_plugin != null) {
                right_side = this.list_plugin_recommended
            }

        }


        let left_data_resp = left_side.response();
        let right_data_resp = right_side.response();


        // let left_rowData = (left_data_resp.result && left_data_resp.result.rows) || [];
        // let left_rowMeta = left_data_resp.meta || {};

        // let right_rowData = (right_data_resp.result && right_data_resp.result.rows) || [];
        // let right_rowMeta = right_data_resp.meta || {};


        let reconciler = this.props.reconciler || {};
        let references = reconciler.__references__ || {};
        let our_datatype = references.our_data_type_id || {};
        let their_datatype = references.their_data_type_id || {};

        const sort_menu_left = (
            <Menu onClick={(params) => {
                //   console.log("params ", params);
                var new_filter = {
                    ...filter_left,
                    order: JSON.stringify([params.key])
                }
                this.setState({
                    selected_left: null,
                    selected_left_transaction: {},
                    selected_left_index: null,
                    batch_mode: 'Manual',
                    filter_left: new_filter
                }, () => {
                    console.log("filtering for", filter_left)
                    left_side.config({
                        params: {
                            ...new_filter,
                            page: 1
                        }
                    })
                        .execute();
                });
            }}>
                <Menu.Item key="-amount">
                    Amount(High to Low)
                </Menu.Item>
                <Menu.Item key="amount">
                    Amount(Low to High)
                </Menu.Item>
                <Menu.Item key="-txn_date">Txn Date(Recent First)</Menu.Item>
                <Menu.Item key="txn_date">Txn Date(Old First)</Menu.Item>
            </Menu>
        );

        const sort_menu_right = (
            <Menu onClick={(params) => {
                console.log("params ", params, filter_left);
                var new_filter = {
                    ...filter_right,
                    order: JSON.stringify([params.key])
                }
                this.setState({
                    selected_right: null,
                    filter_right: new_filter
                }, () => {
                    console.log("filtering for", filter_right)
                    right_side.config({
                        params: {
                            ...new_filter,
                            page: 1
                        }
                    })
                        .execute();
                });
            }}>
                <Menu.Item key="-amount">
                    Amount(High to Low)
                </Menu.Item>
                <Menu.Item key="amount">
                    Amount(Low to High)
                </Menu.Item>
                <Menu.Item key="-txn_date">Txn Date(Recent First)</Menu.Item>
                <Menu.Item key="txn_date">Txn Date(Old First)</Menu.Item>
            </Menu>
        );

        const _renderRightTopPart=()=>{
            return <div style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: 0,
                paddingBottom: 20,
                height:52
            }}> 
            <div  style={{
                display:'flex',
                flexDirection:'row',
                gap:8,
                flex:1
            }}>
                <TransparentButton onClick={()=>{
                    const ids = right_rowData.map((x)=>x.id);
                    this.setState({
                        selected_right_txn_for_batch:ids
                    })
                }} label={"Select All"}/>
                {this.state.selected_right_txn_for_batch.length>0&&<TransparentButton onClick={()=>{
                    this.setState({
                        selected_right_txn_for_batch:[]
                    })
                }} label={"Deselect All"}/>}

            </div>
            <div  style={{
                display:'flex',
                flexDirection: 'row-reverse',
                gap:8,
                flex:1
            }}>
 {
                    this.state.selected_right_txn_for_batch.length > 0 && !selected_left &&
                    <CustomButton
                        icon={<LibraryAdd />}
                        className='primary-btn transparent'
                        onClick={() => {
                            this.setState({
                                selected_right:[]
                            })
                        }}
                        label="Create Batch"
                    />
                }

                {this.state.selected_right_txn_for_batch.length > 0 && selected_left &&
                    <CustomButton
                        icon={<LibraryAdd />}
                        className='primary-btn'
                        onClick={() => {
                            this.add_peers.config({
                                params: {
                                    txn_id: selected_left,
                                    peer_txn_list: this.state.selected_right_txn_for_batch,
                                    // ...body
                                }
                            }).execute({
                                peer_txn_list:this.state.selected_right_txn_for_batch,
                                // ...body
                            });

                            setTimeout(() => {
                                left_side.execute();
                            }, 500)
                        }}
                        label="Add to Batch"
                    />
                }
            </div>
            </div>
        }
        return (
            <React.Fragment>
                <PopUpForm
                    forCreate={true}
                    show_title_only
                    title="Create Batch"
                    open={this.state.selected_right}
                    onClose={() => {
                        this.setState({
                            selected_right: null
                        })
                    }}
                    // initialData={{}}
                    networkState={create_aggregate_resp}
                    fields={[
                        { index: 'name', type: 'text', name: "Batch Name" }
                    ]}
                    onSubmit={(data) => {
                        this.create_aggregate.config({
                            params: {
                                // id: this.state.selected_right,
                            }
                        }).execute({
                            ...data,
                            peer_txn_list:this.state.selected_right_txn_for_batch
                        })
                    }}
                />
                <PopUpForm
                    forCreate={true}
                    show_title_only
                    title="Plugin Extra Data"
                    open={this.state.extra_plugin_data_modal}
                    onClose={() => {
                        this.setState({
                            extra_plugin_data_modal: false
                        })
                    }}
                    initialData={this.state.plugins_extra_data}
                    networkState={{}}
                    fields={plugins_extra_schema}
                    onSubmit={(data) => {
                        this.setState({ extra_plugin_data_modal: false, plugins_extra_data: data })
                        right_side.config({
                            params: {
                                ...filter_right_recommendation,
                                plugin_data: data,
                                plugin_id: selected_plugin
                            }
                        }).execute();
                    }}
                />
                <Modal
                    visible={this.state.view_transaction_modal}
                    width={'90%'}
                    destroyOnClose
                    footer={null}
                    className='transaction-modal'
                    centered
                    onCancel={() => {
                        this.setState({
                            view_transaction_modal: false,
                            view_transaction_id: null
                        })
                    }}
                >
                    <ModalTransactionDetail
                        onClose={() => {
                            this.setState({
                                view_transaction_modal: false,
                                view_transaction_id: null
                            })
                        }}
                        isModal={true}
                        match={{
                            params: {
                                transaction_id: this.state.view_transaction_id
                            }
                        }}
                    />
                </Modal>

                <Row type='flex' justify='space-between' style={{ flexWrap: 'nowrap', overflowX: 'scroll', minWidth: 900, flex: 1 }}>
                    <div ref={this.drawer_container} style={{ width: '50%', overflowX: 'hidden', position: 'relative', height: '100%', marginBottom: 0, boxShadow: COLORS.unreconciled_box_shadow }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            height: '100%',
                            justifyContent: 'space-between'
                        }}>
                            <div className='unreconciled-top' style={{
                                padding: 8,
                                backgroundColor: COLORS.white,
                                boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
                                zIndex: 9
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    paddingTop: 0,
                                    paddingBottom: 20
                                }}>
                                    <span className='sub-heading-3'>{batch_for == OURS_KEY ? "OURS AGGREGATED" : "THEIRS AGGREGATED"}</span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span className='heading-2' style={{
                                        color: COLORS.primary
                                    }}>{batch_for == OURS_KEY ? our_datatype.name : their_datatype.name}</span>
                                    &nbsp;&nbsp;&nbsp;
                                    <SyncAltRounded titleAccess="Switch OURS and THEIRS" className='toggle-icon hand-cursor'
                                        onClick={() => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right_recommendation',
                                                valueKey: 'type',
                                                value: OURS_KEY ? THEIRS_KEY : OURS_KEY
                                            });

                                            if (batch_for === OURS_KEY) {
                                                // switching to theirs
                                                this.reloadForTheirs();

                                            } else {
                                                // swithching to ours
                                                this.reloadForOurs()
                                            }
                                            this.setState({
                                                batch_for: batch_for === OURS_KEY ? THEIRS_KEY : OURS_KEY,
                                                selected_left: null,
                                                selected_left_transaction: {},
                                                loading_ours: true,
                                                loading_theirs: true,
                                                filter_ours: {},
                                                filter_theirs: {},
                                                batch_mode: 'Manual',
                                                plugins_extra_data: {},
                                                selected_plugin: null
                                            })
                                        }}
                                    />

                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}>
                                        <div className='hand-cursor'
                                            onClick={() => {
                                                this.setState({
                                                    filterVisible_left: !filterVisible_left
                                                })
                                            }}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center'
                                            }}>
                                            <FilterListOutlined className='filter-icon' style={{
                                                // color:hasFilter?COLORS.success_primary:null
                                            }} />
                                            &nbsp;
                                            {filterVisible_left ? "Hide" : "Show"} Filters
                                            {filterVisible_left ?
                                                <ExpandLessOutlined />
                                                :
                                                <ExpandMoreOutlined />}
                                        </div>
                                        &nbsp;
                                        <Dropdown overlay={sort_menu_left} trigger={['click']} placement='bottomRight'>
                                            <div style={{ marginLeft: 20 }} className="ant-dropdown-link hand-cursor" href="#">
                                                Sort By <KeyboardArrowDownOutlined type="down" />
                                            </div>
                                        </Dropdown>
                                        <RefreshOutlined style={{
                                            marginLeft: 20
                                        }} titleAccess='Refresh' onClick={() => {
                                            // this.setState({
                                            //     selected_left: null,
                                            //     selected_left_transaction: {},
                                            //     selected_left_index:null,
                                            // })
                                            left_side.execute();

                                        }} className='menu-icon main-icon hand-cursor' />
                                    </div>
                                    {typeof this.props.onModeChange === 'function' && <CustomSwitch
                                        title="Switch between Reconcile and Batch"
                                        value={this.props.mode}
                                        trueItem="RECONCILE"
                                        falseItem="BATCH"
                                        onChange={(value) => {
                                            this.props.onModeChange(value)
                                        }}
                                    />}

                                </div>
                                {filterVisible_left && <div>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flexWrap: 'wrap',
                                        paddingTop: 20
                                    }}>
                                        <Input.Search
                                            placeholder="Search Query"
                                            style={{
                                                marginTop: 0,
                                                marginBottom: 10,
                                                marginRight: 10,
                                                width: 200
                                            }}
                                            value={filter_left.query}
                                            onChange={(e) => {
                                                this.stateUpdater({
                                                    stateKey: 'filter_left',
                                                    valueKey: 'query',
                                                    value: e.target.value,
                                                })
                                            }}

                                        />
                                        <DatePicker
                                            placeholder="Transaction Date"
                                            style={{
                                                marginTop: 0,
                                                marginBottom: 10,
                                                marginRight: 10,
                                                width: 200
                                            }}
                                            value={filter_left.txn_date ? moment(filter_left.txn_date, "YYYY-MM-DD") : null}
                                            format="YYYY-MM-DD"
                                            onChange={(date, dateString) => {
                                                this.stateUpdater({
                                                    stateKey: 'filter_left',
                                                    valueKey: 'txn_date',
                                                    value: dateString,
                                                })
                                            }}
                                        />



                                        <Select
                                            allowClear
                                            showSearch
                                            style={{
                                                marginTop: 0,
                                                marginBottom: 10,
                                                marginRight: 10,
                                                width: 200
                                            }}
                                            className={filter_left.service_id ? 'filter-option-selected' : ''}

                                            placeholder="Select Service"
                                            value={filter_left.service_id}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            onChange={(value, e) => {
                                                this.stateUpdater({
                                                    stateKey: 'filter_left',
                                                    valueKey: 'service_id',
                                                    value: value,
                                                });
                                            }}
                                        >
                                            {service_list.map((item, index) => {
                                                let source = item;

                                                return <Select.Option title={source.name} value={item.id} key={item.id}>
                                                    {source.name}
                                                </Select.Option>
                                            })}

                                        </Select>
                                        <Select
                                            allowClear
                                            showSearch
                                            style={{
                                                marginTop: 0,
                                                marginBottom: 10,
                                                marginRight: 10,
                                                width: 200
                                            }}
                                            placeholder="Type"
                                            className={filter_left.txn_type ? 'filter-option-selected' : ''}
                                            value={filter_left.txn_type}
                                            // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            onChange={(value, e) => {
                                                this.stateUpdater({
                                                    stateKey: 'filter_left',
                                                    valueKey: 'txn_type',
                                                    value: value,
                                                });
                                            }}
                                        >
                                            <Select.Option value={"D"} key={"D"}>
                                                Debit
                                            </Select.Option>
                                            <Select.Option value={"C"} key={"C"}>
                                                Credit
                                            </Select.Option>
                                            <Select.Option value={"N/A"} key={"N/A"}>
                                                N/A
                                            </Select.Option>

                                        </Select>
                                        <InputNumber
                                            placeholder="Amount"
                                            style={{
                                                marginTop: 0,
                                                marginBottom: 10,
                                                marginRight: 10,
                                                width: 200
                                            }}
                                            value={filter_left.amount} onChange={(value) => {
                                                this.stateUpdater({
                                                    stateKey: 'filter_left',
                                                    valueKey: 'amount',
                                                    value: value,
                                                })
                                            }} />
                                        <InputNumber
                                            placeholder="Offset"
                                            disabled={!filter_left.amount}
                                            style={{
                                                marginTop: 0,
                                                marginBottom: 10,
                                                marginRight: 10,
                                                width: 200
                                            }}
                                            value={filter_left.offset} onChange={(value) => {
                                                this.stateUpdater({
                                                    stateKey: 'filter_left',
                                                    valueKey: 'offset',
                                                    value: value,
                                                })
                                            }} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 8, paddingBottom: 8 }}>
                                        <CustomButton
                                            className='primary-btn'
                                            onClick={() => {
                                                left_side.config({
                                                    params: {
                                                        ...filter_left
                                                    }
                                                }).execute();
                                            }}
                                            label="FILTER"
                                        />

                                        <CustomButton
                                            className='danger-btn'
                                            onClick={() => {
                                                this.setState({
                                                    filter_left: {
                                                        per_page: 20,
                                                        page: 1,
                                                        source_id: this.props.source_id
                                                    },
                                                }, () => {
                                                    left_side.config({
                                                        params: {
                                                            per_page: 20,
                                                            page: 1,
                                                            source_id: this.props.source_id
                                                        }
                                                    }).execute()
                                                })
                                            }}
                                            label="CLEAR ALL"
                                        />
                                        {/* <Button type='primary' size='small' style={{ marginLeft: 4, marginRight: 4 }}
                                                onClick={() => {
                                                    left_side.config({
                                                        params: {
                                                            ...filter_left
                                                        }
                                                    }).execute();
                                                }}
                                            >Filter</Button> */}
                                        {/* <Button type='danger' size='small' onClick={() => {
                                                this.setState({
                                                    filter_left: {},
                                                }, () => {
                                                    left_side.config({
                                                        params: {

                                                        }
                                                    }).execute()
                                                })
                                            }}>Clear All</Button> */}
                                    </div>
                                </div>}

                            </div>
                            <ErrorWrapper error={left_data_resp} onReload={() => {
                                left_side.execute()
                            }}>
                                <div style={{
                                    height: '100%',
                                    overflow: 'scroll',
                                    padding: '0px 10px 0px 12px',
                                    backgroundColor: 'rgba(0,0,0,0.02)'
                                }}>
                                    <Table
                                        loading={left_data_resp.fetching}
                                        className='padding-top-table main-table no-separator-table no-lr-padding-table '
                                        style={{
                                            // backgroundColor:'inherit'
                                        }}
                                        size='small'
                                        bordered={false}
                                        showHeader={false}
                                        pagination={{
                                            simple: false,
                                            position: 'bottom',
                                            size: 'small',
                                            onChange: (current, size) => {

                                                this.setState({
                                                    selected_left: null,
                                                    selected_left_transaction: {},
                                                    selected_left_index: null,
                                                    batch_mode: 'Manual',
                                                }, () => {
                                                    left_side.config({
                                                        params: {
                                                            ...filter_left,
                                                            per_page: size,
                                                            page: current
                                                        }
                                                    })
                                                        .execute();
                                                });

                                            },
                                            defaultCurrent: 1,
                                            current: left_rowMeta.pagination && parseInt(left_rowMeta.pagination.split('/')[0]),
                                            pageSize: (left_rowMeta && left_rowMeta.requested_count),
                                            total: (left_rowMeta && left_rowMeta.total_count),
                                            showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
                                        }}
                                        dataSource={left_rowData}
                                        columns={left_cols({
                                            onAssignClick: (id, data = {}, selected_index) => {
                                                console.log("assigned index", selected_index)
                                                if (id) {
                                                    let selected_transaction = JSON.parse(JSON.stringify(data));
                                                    let description = selected_transaction.description || "";
                                                    let result = description.match('ManualBatched:\s*(.{1,250}?)- Batch Name:') || description.match('ManualBatched:\s*(.*)\s*(?:-\s*Batch Name:)?') || ["", ""];
                                                    console.log("result is", result)
                                                    let desc = result[1] || description.substr(0, 250);
                                                    desc = desc.substr(0, 250);


                                                    this.list_peers.config({
                                                        params: {
                                                            txn_id: id,
                                                            pagination: false
                                                        }
                                                    }).execute();
                                                    this.setState({
                                                        selected_left: id,
                                                        selected_left_transaction: data,
                                                        selected_left_index: selected_index,
                                                        batch_mode: 'Recommended',
                                                        selected_right_txn_for_batch:[]
                                                        // plugins_extra_data:{},
                                                        // selected_plugin:null
                                                    })

                                                    this.stateUpdater({
                                                        stateKey: 'filter_right_recommendation',
                                                        appendObj: {
                                                            type: batch_for,
                                                            desc: desc,
                                                        },
                                                        callback: (filter_val = {}) => {
                                                            this.list_recommended.config({
                                                                params: {
                                                                    id: selected_transaction.id,
                                                                    ...filter_val
                                                                }
                                                            }).execute();

                                                        }
                                                    });

                                                } else {
                                                    // unselect given transaction
                                                    this.setState({
                                                        selected_left: null,
                                                        selected_left_transaction: data,
                                                        selected_left_index: null,
                                                        batch_mode: 'Manual',
                                                        selected_right_txn_for_batch:[]
                                                    }, () => {
                                                        if (this.state.batch_for == OURS_KEY) {
                                                            this.list_our_normal.execute();
                                                        } else {
                                                            this.list_their_normal.execute();
                                                        }
                                                    })

                                                }

                                            },
                                            onViewDetailClicked: (id) => {
                                                this.setState({
                                                    view_transaction_id: id,
                                                    view_transaction_modal: true
                                                })
                                            },
                                            batch_mode: batch_mode,
                                            selected_left: selected_left,
                                            side: 'left',
                                            selected_id: selected_left,
                                            list_peers_resp: list_peers_resp,
                                            remove_peers_resp: remove_peers_resp,
                                            onPeerRefresh: () => {
                                                this.list_peers.execute();
                                            },
                                            onRemoveClicked: (peer_id) => {
                                                this.remove_peers.config({
                                                    params: {
                                                        txn_id: selected_left,
                                                        // peer_id: peer_id
                                                    }
                                                }).execute({
                                                    peer_txn_list:[peer_id]
                                                });
                                                setTimeout(() => {
                                                    left_side.execute();
                                                }, 500)
                                            },
                                            onDeleteBatch:(id)=>{
                                                this.delete_aggregate.execute({
                                                    txn_id:id
                                                });
                                            }

                                        })}
                                    />
                                </div>
                            </ErrorWrapper>
                        </div>

                    </div>
                    <div style={{ width: 30, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                    </div>


                    {/* RIGHT SIDE */}
                    <div style={{ width: '50%', height: '100%', marginBottom: 0, boxShadow: COLORS.unreconciled_box_shadow }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            height: '100%',
                            justifyContent: 'space-between'
                        }}>

                            {batch_mode == 'Recommended' && <div className='unreconciled-top' style={{
                                padding: 8,
                                backgroundColor: COLORS.white,
                                boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
                                zIndex: 9
                            }}>
                                {_renderRightTopPart()}

                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}>
                                        <div className='hand-cursor'
                                            onClick={() => {
                                                this.setState({
                                                    filterVisible_right_recommendation: !filterVisible_right_recommendation
                                                })
                                            }}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center'
                                            }}>
                                            <FilterListOutlined className='filter-icon' style={{
                                                // color:hasFilter?COLORS.success_primary:null
                                            }} />
                                            &nbsp;
                                            {filterVisible_right_recommendation ? "Hide" : "Show"} Filters
                                            &nbsp; &nbsp;
                                            {filterVisible_right_recommendation ?
                                                <ExpandLessOutlined />
                                                :
                                                <ExpandMoreOutlined />}
                                        </div>
                                        <RefreshOutlined titleAccess='Refresh' onClick={() => {
                                            right_side.execute();

                                        }} className='menu-icon main-icon hand-cursor' />

                                    </div>

                                    <CustomSwitch
                                        title="Switch between Recommended and Manual"
                                        value={batch_mode}
                                        disabled={!selected_left}
                                        disabledTitle="Please select any transaction from left to switch to Recommended"
                                        trueItem="Recommended"
                                        // ti
                                        falseItem="Manual"
                                        onChange={(value) => {
                                            console.log("value is", value)
                                            console.log("switching", value, this.state.batch_for, this.state.batch_mode)

                                            if (this.state.batch_for == OURS_KEY) {
                                                if (value == 'Recommended') {
                                                    // this.setState({
                                                    //     plugins_extra_data: {},
                                                    //     selected_plugin: null,
                                                    //     plugins_extra_schema:[]
                                                    // })
                                                    right_side.config({
                                                        params: {
                                                            ...filter_right_recommendation,
                                                            ...selected_plugin != null ? {
                                                                plugin_data: plugins_extra_data,
                                                                plugin_id: selected_plugin
                                                            } : {},
                                                        }
                                                    }).execute();
                                                } else {
                                                    this.list_our_normal.execute();
                                                }
                                            } else {
                                                if (value == 'Recommended') {
                                                    // this.list_recommended.execute();
                                                    right_side.config({
                                                        params: {
                                                            ...filter_right_recommendation,
                                                            ...selected_plugin != null ? {
                                                                plugin_data: plugins_extra_data,
                                                                plugin_id: selected_plugin
                                                            } : {},
                                                        }
                                                    }).execute();
                                                } else {
                                                    this.list_their_normal.execute();
                                                }
                                            }

                                            this.setState({
                                                batch_mode: value,
                                                selected_right_txn_for_batch:[]
                                            })
                                        }}

                                    />
                                </div>

                                {filterVisible_right_recommendation && <div> <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flexWrap: 'wrap',
                                    paddingTop: 20
                                }}>
                                    <Input.TextArea
                                        maxLength={255}
                                        placeholder="Description"
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                        }}
                                        value={filter_right_recommendation.desc}
                                        onChange={(e) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right_recommendation',
                                                valueKey: 'desc',
                                                value: e.target.value,
                                            })
                                        }}

                                    />

                                    <Select
                                        allowClear
                                        showSearch
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                            width: 200
                                        }}
                                        className={filter_right_recommendation.txn_type ? 'filter-option-selected' : ''}
                                        placeholder="Type"
                                        value={filter_right_recommendation.txn_type}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={(value, e) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right_recommendation',
                                                valueKey: 'txn_type',
                                                value: value,
                                            });
                                        }}
                                    >
                                        <Select.Option value={"D"} key={"D"}>
                                            Debit
                                        </Select.Option>
                                        <Select.Option value={"C"} key={"C"}>
                                            Credit
                                        </Select.Option>
                                        <Select.Option value={"N/A"} key={"N/A"}>
                                            N/A
                                        </Select.Option>

                                    </Select>

                                    <Select
                                        allowClear
                                        showSearch
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                            width: 200
                                        }}
                                        className={selected_plugin ? 'filter-option-selected' : ''}
                                        placeholder="Plugin"
                                        value={filter_right_recommendation.txn_type}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={(value, e) => {
                                            // this.stateUpdater({
                                            //     stateKey: 'filter_right_recommendation',
                                            //     valueKey: 'txn_type',
                                            //     value: value,
                                            // });
                                            let new_data_schema = [];
                                            if (value != null) {
                                                new_data_schema = schema_to_field((plugins_data[value] && plugins_data[value].validation_config) || [])
                                            }
                                            this.setState({
                                                selected_plugin: value,
                                                plugins_extra_schema: new_data_schema
                                            })
                                        }}
                                    >
                                        {Object.keys(plugins_data).map((key) => {
                                            let item = plugins_data[key];
                                            return <Select.Option title={item.name} key={item.id} value={item.id}>{item.name}</Select.Option>
                                        })}

                                    </Select>
                                    {selected_plugin != null && plugins_extra_schema.length > 0 &&

                                        <Button shape='circle'
                                            onClick={() => {
                                                this.setState({ extra_plugin_data_modal: true })
                                            }}
                                            type='primary'
                                            style={{ marginLeft: 16 }}
                                            title="Plugin Data"
                                            icon={<FilterList style={{
                                                width: 20
                                            }} />}
                                        ></Button>}

                                </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 8, paddingBottom: 8 }}>

                                        <CustomButton
                                            className='primary-btn'
                                            onClick={() => {

                                                // right_side.config({
                                                //     params: {
                                                //         ...filter_right_recommendation,

                                                //     }
                                                // }).execute();
                                                right_side.config({
                                                    params: {
                                                        ...filter_right_recommendation,
                                                        ...selected_plugin != null ? {
                                                            plugin_data: plugins_extra_data,
                                                            plugin_id: selected_plugin
                                                        } : {},
                                                    }
                                                }).execute();
                                            }}
                                            label="FILTER"
                                        />

                                        {/* <CustomButton
                                                        className='danger-btn'
                                                        onClick={()=>{
                                                            this.setState({
                                                                filter_left: {},
                                                            }, () => {
                                                                left_side.config({
                                                                    params: {

                                                                    }
                                                                }).execute()
                                                            })
                                                        }}
                                                        label="CLEAR ALL"
                                                        /> */}

                                        {/* <Button type='primary' size='small' style={{ marginLeft: 4, marginRight: 4 }}
                                                onClick={() => {
                                                    right_side.config({
                                                        params: {
                                                            ...filter_right_recommendation
                                                        }
                                                    }).execute();
                                                }}
                                            >Filter</Button> */}
                                        {/* <Button type='danger' size='small' onClick={() => {
                                                this.setState({
                                                    filter_right_recommendation: {
                                                        type:filter_right_recommendation.type
                                                    },
                                                }, () => {
                                                    right_side.config({
                                                        params: {

                                                        }
                                                    }).execute()
                                                })
                                            }}>Clear All</Button> */}
                                    </div>
                                </div>}
                            </div>}
                            {batch_mode == 'Manual' && <div className='unreconciled-top' style={{
                                padding: 8,
                                backgroundColor: COLORS.white,
                                boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
                                zIndex: 9
                            }}>
                                {_renderRightTopPart()}

                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}>
                                        <div className='hand-cursor'
                                            onClick={() => {
                                                this.setState({
                                                    filterVisible_right: !filterVisible_right
                                                })
                                            }}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center'
                                            }}>
                                            <FilterListOutlined className='filter-icon' style={{
                                                // color:hasFilter?COLORS.success_primary:null
                                            }} />
                                            &nbsp;
                                            {filterVisible_right ? "Hide" : "Show"} Filters
                                            {filterVisible_right ?
                                                <ExpandLessOutlined />
                                                :
                                                <ExpandMoreOutlined />}
                                        </div>
                                        &nbsp;
                                        <Dropdown overlay={sort_menu_right} trigger={['click']} placement='bottomRight'>
                                            <div style={{ marginLeft: 20 }} className="ant-dropdown-link hand-cursor" href="#">
                                                Sort By <KeyboardArrowDownOutlined type="down" />
                                            </div>
                                        </Dropdown>
                                        <RefreshOutlined style={{
                                            marginLeft: 20
                                        }} titleAccess='Refresh' onClick={() => {
                                            right_side.execute();

                                        }} className='menu-icon main-icon hand-cursor' />
                                    </div>

                                    {/* RECOMM MODE  SWITCH*/}
                                    <CustomSwitch
                                        title="Switch between Recommended and Manual"
                                        value={batch_mode}
                                        disabled={!selected_left}
                                        disabledTitle="Please select any transaction from left to switch to Recommended"
                                        trueItem="Recommended"
                                        falseItem="Manual"
                                        onChange={(value) => {

                                            if (this.state.batch_for == OURS_KEY) {
                                                if (value == 'Recommended') {
                                                    this.list_recommended.execute();
                                                } else {
                                                    this.list_our_normal.execute();
                                                }
                                            } else {
                                                if (value == 'Recommended') {
                                                    this.list_recommended.execute();
                                                } else {
                                                    this.list_their_normal.execute();
                                                }
                                            }

                                            this.setState({
                                                batch_mode: value,
                                                selected_right_txn_for_batch:[]
                                            })
                                        }}

                                    />
                                </div>

                                {filterVisible_right && <div><div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flexWrap: 'wrap',
                                    paddingTop: 20
                                }}>
                                    <Input.Search
                                        placeholder="Search Query"
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                            width: 200
                                        }}
                                        value={filter_right.query}
                                        onChange={(e) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right',
                                                valueKey: 'query',
                                                value: e.target.value,
                                            })
                                        }}

                                    />
                                    <DatePicker
                                        placeholder="Transaction Date"
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                            width: 200
                                        }}
                                        value={filter_right.txn_date ? moment(filter_right.txn_date, "YYYY-MM-DD") : null}
                                        format="YYYY-MM-DD"
                                        onChange={(date, dateString) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right',
                                                valueKey: 'txn_date',
                                                value: dateString,
                                            })
                                        }}
                                    />



                                    <Select
                                        allowClear
                                        showSearch
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                            width: 200
                                        }}
                                        className={filter_right.service_id ? 'filter-option-selected' : ''}
                                        placeholder="Select Service"
                                        value={filter_right.service_id}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={(value, e) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right',
                                                valueKey: 'service_id',
                                                value: value,
                                            });
                                        }}
                                    >
                                        {service_list.map((item, index) => {
                                            let source = item;

                                            return <Select.Option title={source.name} value={item.id} key={item.id}>
                                                {source.name}
                                            </Select.Option>
                                        })}

                                    </Select>

                                    <Select
                                        allowClear
                                        showSearch
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                            width: 200
                                        }}
                                        placeholder="Type"
                                        className={filter_right.txn_type ? 'filter-option-selected' : ''}
                                        value={filter_right.txn_type}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={(value, e) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right',
                                                valueKey: 'txn_type',
                                                value: value,
                                            });
                                        }}
                                    >
                                        <Select.Option value={"D"} key={"D"}>
                                            Debit
                                        </Select.Option>
                                        <Select.Option value={"C"} key={"C"}>
                                            Credit
                                        </Select.Option>
                                        <Select.Option value={"N/A"} key={"N/A"}>
                                            N/A
                                        </Select.Option>

                                    </Select>
                                    <InputNumber
                                        placeholder="Amount"
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                            width: 200
                                        }}
                                        value={filter_right.amount} onChange={(value) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right',
                                                valueKey: 'amount',
                                                value: value,
                                            })
                                        }} />
                                    <InputNumber
                                        placeholder="Offset"
                                        disabled={!filter_right.amount}
                                        style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                            marginRight: 10,
                                            width: 200
                                        }}
                                        value={filter_right.offset} onChange={(value) => {
                                            this.stateUpdater({
                                                stateKey: 'filter_right',
                                                valueKey: 'offset',
                                                value: value,
                                            })
                                        }} />
                                </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 8, paddingBottom: 8 }}>
                                        <CustomButton
                                            className='primary-btn'
                                            onClick={() => {
                                                right_side.config({
                                                    params: {
                                                        ...filter_right
                                                    }
                                                }).execute();
                                            }}
                                            label="FILTER"
                                        />
                                        <CustomButton
                                            className='danger-btn'
                                            onClick={() => {
                                                this.setState({
                                                    filter_right: {
                                                        per_page: 20,
                                                        page: 1,
                                                        source_id: this.props.source_id
                                                    },
                                                }, () => {
                                                    right_side.config({
                                                        params: {
                                                            per_page: 20,
                                                            page: 1,
                                                            source_id: this.props.source_id
                                                        }
                                                    }).execute()
                                                })
                                            }}
                                            label="CLEAR ALL"
                                        />
                                    </div>
                                </div>}
                            </div>}

                            <ErrorWrapper
                                error={right_data_resp}
                                onReload={() => {
                                    right_side.execute()
                                }}
                            >
                                <div style={{
                                    height: '100%',
                                    overflow: 'scroll',
                                    padding: '0px 10px 0px 12px',
                                    backgroundColor: 'rgba(0,0,0,0.02)'
                                }}>
                                    <Table
                                        loading={right_data_resp.fetching || create_aggregate_resp.fetching || add_peers_resp.fetching}
                                        className='padding-top-table main-table no-separator-table no-lr-padding-table'
                                        style={{
                                            // backgroundColor:'inherit'
                                        }}
                                        showHeader={false}
                                        pagination={{
                                            simple: false,
                                            position: 'bottom',
                                            size: 'small',
                                            onChange: (current, size) => {
                                                let ext_filter = batch_mode == 'Recommended' ? filter_right_recommendation : filter_right;
                                                right_side.config({
                                                    params: {
                                                        ...ext_filter,
                                                        per_page: size,
                                                        page: current
                                                    }
                                                })
                                                    .execute();
                                            },
                                            defaultCurrent: 1,
                                            current: right_rowMeta.pagination && parseInt(right_rowMeta.pagination.split('/')[0]),
                                            pageSize: (right_rowMeta && right_rowMeta.requested_count),
                                            total: (right_rowMeta && right_rowMeta.total_count),
                                            showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
                                        }}
                                        dataSource={right_rowData}
                                        columns={right_cols({
                                            selected_right_txn_for_batch: this.state.selected_right_txn_for_batch,
                                            onSelect: (id) => {
                                                let _ids = [...this.state.selected_right_txn_for_batch];
                                                let _ind = _ids.indexOf(id);
                                                if (_ind === -1) {
                                                    _ids.push(id)
                                                } else {
                                                    _ids.splice(_ind, 1)
                                                }
                                                this.setState({
                                                    selected_right_txn_for_batch: _ids
                                                })
                                            },
                                            onAssignClick: () => { },
                                            onViewDetailClicked: (id) => {
                                                this.setState({
                                                    view_transaction_id: id,
                                                    view_transaction_modal: true
                                                })
                                            },
                                            batch_mode: batch_mode,
                                            selected_left: selected_left,
                                            onCreateBatch: (id) => {
                                                this.setState({
                                                    selected_right: id
                                                })
                                            },
                                            onAddToBatch: (id, body = {}) => {
                                                this.add_peers.config({
                                                    params: {
                                                        txn_id: selected_left,
                                                        peer_id: id,
                                                        ...body
                                                    }
                                                }).execute({
                                                    peer_id: id,
                                                    ...body
                                                });

                                                setTimeout(() => {
                                                    left_side.execute();
                                                }, 500)

                                            },
                                            side: 'right'
                                        })}
                                    />
                                </div>
                            </ErrorWrapper>
                        </div>
                    </div>
                </Row>

            </React.Fragment>
        );
    }
}

export default BatchMode = withDomains(BatchMode, "batching", "allData");

const left_cols = ({ onAssignClick,
    selected_id,
    onViewDetailClicked,
    batch_mode,
    selected_left, onCreateBatch, onAddToBatch, side,
    remove_peers_resp,
    list_peers_resp,
    onRemoveClicked,
    onPeerRefresh,
    onDeleteBatch
}) => [
        {
            // title: <center><Title level={4} type='secondary'>Recommended List</Title></center>,
            key: '',
            render: (record, row, index) => {

                let item = record;

                return <TransactionBatchAggregatedItem
                onDeleteBatch={onDeleteBatch}
                    side={side}
                    batch_mode={batch_mode}
                    item_type={batch_mode}
                    selected_left={selected_left}
                    onCreateBatch={onCreateBatch}
                    isSelectable
                    selectedID={selected_id}
                    itemID={item.id}
                    onViewDetailClicked={onViewDetailClicked}
                    onSelected={(id, data) => {
                        typeof onAssignClick === 'function' && onAssignClick(id, data, index)
                    }}
                    data={item}
                    key={`${index}-transaction`}
                    index={index}
                    onPeerRefresh={onPeerRefresh}
                    onRemoveClicked={onRemoveClicked}
                    remove_peers_resp={remove_peers_resp}
                    list_peers_resp={list_peers_resp}
                />
            }
        }

    ]
const right_cols = ({ onAssignClick,
    selected_id,
    onViewDetailClicked,
    batch_mode,
    selected_left, onCreateBatch, onAddToBatch, side,
    selected_right_txn_for_batch,
    onSelect }) => [
        {
            // title: <center><Title level={4} type='secondary'>Recommended List</Title></center>,
            key: '',
            render: (item) => {
                return <TransactionBatchIndividualItem
                    selected_right_txn_for_batch={selected_right_txn_for_batch}
                    onSelect={onSelect}
                    side={side}
                    batch_mode={batch_mode}
                    item_type={batch_mode}
                    selected_left={selected_left}
                    onCreateBatch={onCreateBatch}
                    onAddToBatch={onAddToBatch}
                    // isSelectable
                    selectedID={selected_id}
                    itemID={item.id}
                    onViewDetailClicked={onViewDetailClicked}
                    onSelected={(id, data) => {
                        typeof onAssignClick === 'function' && onAssignClick(id, data)
                    }}
                    data={item}
                    key={item.id} />
            }
        }

    ]
